import { render, staticRenderFns } from "./buildPhase.vue?vue&type=template&id=6b9cff24&scoped=true&"
import script from "./buildPhase.vue?vue&type=script&lang=js&"
export * from "./buildPhase.vue?vue&type=script&lang=js&"
import style0 from "./buildPhase.vue?vue&type=style&index=0&id=6b9cff24&scoped=true&lang=css&"
import style1 from "./buildPhase.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9cff24",
  null
  
)

export default component.exports